import { render, staticRenderFns } from "./task_save_as_dailog.vue?vue&type=template&id=c38ba57c&scoped=true"
import script from "./task_save_as_dailog.vue?vue&type=script&lang=js"
export * from "./task_save_as_dailog.vue?vue&type=script&lang=js"
import style0 from "./task_save_as_dailog.vue?vue&type=style&index=0&id=c38ba57c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38ba57c",
  null
  
)

export default component.exports